import { createSlice } from "@reduxjs/toolkit";
import { setMessage } from "./messageReducer";
import { CompareService } from "services/api/compare";

export const compareSlice = createSlice({
  name: "compareReducer",
  initialState: {
    flagQuery: 1,
    cities: [],
    favorites: [],
    citiesLoading: false,
    firstCity: null,
    secondCity: null,
    cityLoading: false,
  },
  reducers: {
    setCities: (state, action) => {
      state.cities = action.payload;
    },

    pushCities: (state, action) => {
      state.cities.push(...action.payload);
    },

    setFlagQuery: (state, action) => {
      state.flagQuery = action.payload;
    },

    setCitiesLoading: (state, action) => {
      state.citiesLoading = action.payload;
    },

    setCityLoading: (state, action) => {
      state.cityLoading = action.payload;
    },

    setFirstCity: (state, action) => {
      state.firstCity = action.payload;
    },

    setSecondCity: (state, action) => {
      state.secondCity = action.payload;
    },

    addFavorite: (state, action) => {
      state.favorites.push(action.payload);
    },

    removeFavorite: (state, action) => {
      state.favorites = state.favorites.filter(
        (x) => x.geoid !== action.payload
      );
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCities,
  pushCities,
  setCitiesLoading,
  setFlagQuery,
  setCityLoading,
  setFirstCity,
  setSecondCity,
  addFavorite,
  removeFavorite,
} = compareSlice.actions;

export const getStateCities = (payload) => async (dispatch) => {
  dispatch(setCitiesLoading(true));
  try {
    const { data } = await CompareService.getStateCities(payload);
    dispatch(setCities(data.body));
  } catch (err) {
    dispatch(setMessage({ message: err.message }));
  }
  dispatch(setCitiesLoading(false));
};

export const pushStateCities = (payload) => async (dispatch) => {
  dispatch(setCitiesLoading(true));
  try {
    const { data } = await CompareService.getStateCities(payload);
    dispatch(pushCities(data.body));
  } catch (err) {
    dispatch(setMessage({ message: err.message }));
  }
  dispatch(setCitiesLoading(false));
};

export const getCityAtGlance = (payload) => async (dispatch) => {
  const { city, city_match, city_geoid, city_index, state, run_id } = payload;
  const { user_income, user_adults, user_kids } = payload;
  const { user_infants, user_own } = payload;
  dispatch(setCityLoading(true));
  try {
    const { data } = await CompareService.getCityAtGlance({
      city_geoid,
      run_id,
      user_income,
      user_adults,
      user_kids,
      user_infants,
      user_own,
    });
    if (city_index === 1) {
      dispatch(
        setFirstCity({
          name: city,
          state: state,
          match: city_match,
          ...data.body,
        })
      );
    } else {
      dispatch(
        setSecondCity({
          name: city,
          state: state,
          match: city_match,
          ...data.body,
        })
      );
    }
  } catch (err) {
    dispatch(setMessage({ message: err.message }));
  }
  dispatch(setCityLoading(false));
};

export const getCompareCities = (payload) => async (dispatch) => {
  dispatch(setCitiesLoading(true));
  try {
    const { data } = await CompareService.getCompareCities(payload);
    dispatch(setCities(data.body));
  } catch (err) {
    dispatch(setMessage({ message: err.message }));
  }
  dispatch(setCitiesLoading(false));
};

export default compareSlice.reducer;
